import { graphql } from '../gql';

export const getReportsList = graphql(`
  query GetReportsList {
    getReportsConfigurations(input: {application: FOODA_FOR_RESTAURANTS}) {
      error {
        code
        message
      }
      reportsConfigurations {
        menuTitle
        iconName
      }
    }
  }
`);
